import { ref } from 'vue'

export const useHover = () => {
  const hover = ref<boolean>(false)

  const show = () => {
    hover.value = true
  }

  const hide = () => {
    hover.value = false
  }

  return {
    hover,
    show,
    hide,
  }
}
